import { InjectionToken, WritableSignal } from '@angular/core';
import { Params } from '@angular/router';
import { RequiredAccessArray } from '@app/shared/utils';
import { AppState } from '@app/store/app.state';
import { Observable } from 'rxjs';

export interface Shortcut {
  title: string;
  icon: string;
  style: string;
  iconStyle?: string;
  permission?: RequiredAccessArray;
  show?: Observable<boolean>;
  url?: string;
  params?: Params;
  open?: () => Observable<any>;
  redirect?: string;
  target?: string;
  new?: boolean;
  load?: WritableSignal<boolean>;
}

export type Builder = () => Shortcut;
export const SHORTCUT_BUILDERS = new InjectionToken<ShortcutBuilder[]>('SHORTCUT_BUILDERS');

export interface ShortcutBuilder {
  accept(store: AppState): boolean;
  readonly items: Builder[];
}
